/**
 * 역할 선택 모달 — 양쪽 capability 협력사 로그인 시 노출
 *
 * 단일 capability 협력사는 자동 진입하므로 이 모달이 뜨지 않음.
 * 관리자/담당자도 노출 안 됨.
 */

import { Factory, Settings } from 'lucide-react';
import { useState } from 'react';

export default function RoleChooserModal({ availableRoles, onSelect, onCancel }) {
  const [submitting, setSubmitting] = useState(false);

  const handleClick = async (role) => {
    setSubmitting(true);
    try {
      await onSelect(role);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">접속 역할 선택</h2>
        <p className="text-sm text-gray-600 mb-5">
          귀사는 <strong>생산처 + 제작처</strong> 양쪽 모두 등록되어 있습니다.<br />
          이번 접속에서 사용할 역할을 선택해주세요.
        </p>

        <div className="space-y-3">
          {availableRoles?.includes('plant') && (
            <button
              onClick={() => handleClick('plant')}
              disabled={submitting}
              className="w-full flex items-center gap-3 px-4 py-4 border-2 border-blue-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors disabled:opacity-50 group"
            >
              <div className="w-12 h-12 rounded-full bg-blue-100 group-hover:bg-blue-200 flex items-center justify-center">
                <Factory size={24} className="text-blue-600" />
              </div>
              <div className="flex-1 text-left">
                <div className="font-semibold text-gray-900">🏭 생산처</div>
                <div className="text-xs text-gray-500">일상점검, 정기점검, 수리요청, 이관, 폐기</div>
              </div>
            </button>
          )}

          {availableRoles?.includes('maker') && (
            <button
              onClick={() => handleClick('maker')}
              disabled={submitting}
              className="w-full flex items-center gap-3 px-4 py-4 border-2 border-purple-200 rounded-lg hover:border-purple-500 hover:bg-purple-50 transition-colors disabled:opacity-50 group"
            >
              <div className="w-12 h-12 rounded-full bg-purple-100 group-hover:bg-purple-200 flex items-center justify-center">
                <Settings size={24} className="text-purple-600" />
              </div>
              <div className="flex-1 text-left">
                <div className="font-semibold text-gray-900">⚙️ 제작처</div>
                <div className="text-xs text-gray-500">수리작업, 사양확인, 출하체크, 사진업로드</div>
              </div>
            </button>
          )}
        </div>

        {onCancel && (
          <button onClick={onCancel} disabled={submitting}
                  className="mt-4 w-full text-xs text-gray-500 hover:text-gray-700">
            로그아웃하고 다시 로그인
          </button>
        )}

        <p className="mt-4 text-[11px] text-gray-400 text-center">
          접속 중 역할을 변경하려면 헤더의 역할 표시를 클릭하세요
        </p>
      </div>
    </div>
  );
}
